import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { indexMethod } from '@/utils/indexMethod';
export default {
  __name: 'table',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    scheme: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 8
    }
  },
  emits: ['stop', 'charge', 'open'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleStop = row => {
      emit('stop', row);
    };
    const handleCharge = row => {
      emit('charge', row);
    };
    const handleOpen = row => {
      emit('open', row);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.tableData,
        style: {
          "width": "100%"
        },
        ref: "tableRef",
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "#",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.currentPage, __props.pageSize),
          align: "center"
        }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scheme, (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: item.label,
            "min-width": item.minWidth,
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [item.prop === 'applyStatus' ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: row[item.prop] === 1 ? '' : 'warning'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row[item.prop] === 1 ? '使用中' : '停用中'), 1)]),
              _: 2
            }, 1032, ["type"])) : item.prop === 'approvalStatus' ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: row[item.prop] === 1 ? '' : row[item.prop] === 2 ? 'success' : 'danger'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row[item.prop] === 1 ? '进行中 ' : row[item.prop] === 2 ? '审核完成' : '拒绝'), 1)]),
              _: 2
            }, 1032, ["type"])) : item.prop === 'action' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [item.btnArr.includes('charge') && row['applyStatus'] === 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: $event => handleCharge(row)
            }, {
              default: _withCtx(() => [_createTextVNode("续费")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), item.btnArr.includes('open') ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "success",
              size: "small",
              onClick: $event => handleOpen(row)
            }, {
              default: _withCtx(() => [_createTextVNode("详情")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), item.btnArr.includes('stop') && row['applyStatus'] === 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "danger",
              size: "small",
              onClick: $event => handleStop(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 停用 ")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 3
            }, [_createTextVNode(_toDisplayString(row[item.prop]), 1)], 64))]),
            _: 2
          }, 1032, ["label", "min-width"]);
        }), 128))]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]);
    };
  }
};